export default "__VITE_ASSET__576875b8__"